import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { LocalStorageService } from '../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';

@Injectable()
export class MenuTabGuard implements CanActivate {
    constructor(
        private readonly router: Router,
        private readonly localStorageService: LocalStorageService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const menuTab: string = route.data['menuTab'] ?? state.url.split('?')[0];
        if (this.localStorageService.currentUserCanSeeTab(menuTab)) {
            return true;
        }

        const redirectTo: string = route.data['redirectTo'] ?? '/gruppen/aktuelle';
        void this.router.navigateByUrl(redirectTo);
        return false;
    }
}
